import { baseSiteEndPoint, buildHeaders, getSellerID, processResponse } from "./common";
import { authorizedFetch } from "./login";

export const apiSimulationTax = (value, isOnline, sellerManual) =>
  authorizedFetch(`${baseSiteEndPoint}/sales/seller/${sellerManual ? sellerManual : getSellerID()}/simulate`, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify({ amount: value, is_online: isOnline })
  }).then(processResponse);
